module.exports = __webpack_public_path__ + "img/sl_3.8a512a47.jpg";